export const THEME_COLOR = [
    {
        "name": "ค่าเริ่มต้น",
        "nameEn": "Default",
        "code": "DEFAULT",
        "color": {
            "buttonBG": "#2CADE7",
            "buttonText": "#ffffff",
            "sidebarMenu": "#F1FBFC",
            "subSidebarMenu": "#F1FBFC",
            "tabHighlight": "#2CADE7",
            "paginateBg": "#EFF1F4"
        }
    },
    {
        "name": "มิ้นต์ & เบจ",
        "nameEn": "Mint & Beige",
        "code": "THEME2",
        "color": {
            "buttonBG": "#4ED8B3",
            "buttonText": "#ffffff",
            "sidebarMenu": "#DCF7F0",
            "subSidebarMenu": "#DCF7F0",
            "tabHighlight": "#4ED8B3",
            "paginateBg": "#DCF7F0"
        }
    },
    {
        "name": "กรมท่า & ครีม",
        "nameEn": "Navy & Cream",
        "code": "THEME3",
        "color": {
            "buttonBG": "#34495E",
            "buttonText": "#ffffff",
            "sidebarMenu": "#D6DBDF",
            "subSidebarMenu": "#D6DBDF",
            "tabHighlight": "#34495E",
            "paginateBg": "#EFF1F4"
        }
    },
    {
        "name": "ชมพู & เทา",
        "nameEn": "Pink & Gray",
        "code": "THEME4",
        "color": {
            "buttonBG": "#FF6F61",
            "buttonText": "#ffffff",
            "sidebarMenu": "#FFE2DF",
            "subSidebarMenu": "#FFE2DF",
            "tabHighlight": "#FF6F61",
            "paginateBg": "#FFE2DF"
        }
    },
    {
        "name": "ส้ม & เขียวมะนาว",
        "nameEn": "Orange & Lime",
        "code": "THEME5",
        "color": {
            "buttonBG": "#FFA500",
            "buttonText": "#ffffff",
            "sidebarMenu": "#FFEDCC",
            "subSidebarMenu": "#FFEDCC",
            "tabHighlight": "#FFA500",
            "paginateBg": "#FFEDCC"
        }
    }
]
